<template>
    <MainHeader />
    <NavBar v-bind:pages="mainSitePages" />
    <div>
        <slot></slot>
    </div>
    <button
        class="notify-fab"
        v-bind:disabled="isLoadingSubscription"
        v-on:click="() => toggleNotifySubscriptionAsync()"
    >
        <i
            v-bind:class="
                'fa fa-' +
                (!isLoadingSubscription && notifySubscriber.isSubscribed
                    ? 'bell-slash'
                    : 'bell')
            "
        ></i>
    </button>
    <MainFooter />
</template>

<script setup lang="ts">
import { mainSitePages } from "~/client/mainSitePages";

const notifySubscriber = useNotifySubscriberStore();
const isLoadingSubscription = ref(true);

const toggleNotifySubscriptionAsync = async () => {
    if (isLoadingSubscription.value) {
        return;
    }

    isLoadingSubscription.value = true;
    try {
        if (notifySubscriber.isSubscribed) {
            await notifySubscriber.unsubscribeAsync();
        } else {
            await notifySubscriber.subscribeAsync();
        }
    } finally {
        isLoadingSubscription.value = false;
    }
};

onMounted(() => {
    notifySubscriber
        .refreshAsync()
        .then(() => (isLoadingSubscription.value = false));
});
</script>

<style scoped>
div {
    padding-bottom: calc(4 * var(--m-large));
}

.notify-fab {
    position: fixed;
    right: 32px;
    bottom: 32px;
    width: 48px;
    aspect-ratio: 1/1;
    background-color: var(--primary-500);
    color: var(--grey-900);
    border-radius: 100vw;
    border: 2px solid var(--grey-900);
    font-size: var(--font-size-small);
}

.notify-fab:disabled {
    opacity: 0.5;
}
</style>
